export default {
  'sidebar.devolucionproveedor': 'Devoluciones proveedor',
  'devolucion.alerta.agregarDetalles': 'No es posible eliminar el último detalle del documento, por favor verifique.',
  'devolucion.alerta.agregarDetallesAnulado': 'No es posible modificar la información del documento en la etapa actual, por favor verifique.',
  'devolucion.alerta.agregarDetallesCerrado': 'No es posible modificar información de un documento cerrado, por favor verifique.',
};
